var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"full-width font-weight-bold pa-2",class:_vm.customClass,attrs:{"disabled":_vm.disabled,"max-width":_vm.maxWidth},on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }